module.exports = __webpack_public_path__ + "navbg.460fff9d.png";